<template>
  <v-container fluid>
    <!-- <v-card flat> -->
    <!-- <v-toolbar class="elevation-0" height="45" color="gray" v-if="!hideHeader">
        <v-toolbar-title>
          <v-btn text icon @click="$router.go(-1)">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span class="subtitle-1">{{ $t("labels.location") }}</span>
        </v-toolbar-title>
      </v-toolbar> -->
    <!-- <v-card-title class="mt-0" v-if="!$vuetify.breakpoint.xsOnly">
        <v-flex xs12 sm3>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            clearable
          >
          </v-text-field>
        </v-flex>
      </v-card-title> -->
    <v-card-text v-if="!$vuetify.breakpoint.xsOnly">
      <v-data-table :headers="headers" :items="locations" :search="search" :sort-by="sortBy" :page.sync="page"
        hide-default-footer :items-per-page="itemsPerPage">
        <template v-slot:item="{ item }">
          <tr class="pointer" @click="viewLocation(item)">
            <!-- <td class="text-left small-td pointer" v-if="hidden">
                <v-checkbox :input-value="selected" hide-details> </v-checkbox>
              </td> -->
            <td class="text-left small-td pointer">
              {{ item.CSPID }}<v-icon small v-if="item.isLocked">lock</v-icon>
            </td>
            <td class="text-left small-td pointer">
              {{ item.businessName
              }}<v-icon class="ml-1" small v-if="item.isCanceled" color="red">desktop_access_disabled
              </v-icon>
            </td>
            <td class="text-left small-td pointer">{{ item.address }}</td>
            <td class="text-left small-td pointer">{{ item.businessPhone }}</td>
            <td class="text-left small-td pointer">{{ item.businessEmail }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card-text>
    <div v-else>
      <!-- <v-row>
          <v-col cols="12" align="center">
            <h3>Select Location</h3>
          </v-col>
        </v-row> -->
      <v-list two-line>
        <template v-for="(item, index) in locations">
          <div :key="index">
            <v-list-item @click="viewLocation(item)">
              <v-list-item-content>
                <v-list-item-title v-html="item.businessName"> </v-list-item-title>
                <v-list-item-subtitle v-html="item.address"> </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <small>{{ item.CSPID }}</small>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index + 1 < locations.length"></v-divider>
          </div>
        </template>
      </v-list>
    </div>
    <!-- </v-card> -->
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
// import locationService from "../service.js";

export default {
  props: ["hidden", "hideHeader"],
  name: "location-list",
  data() {
    return {
      selected: [],
      terminalURL: process.env.VUE_APP_TERMINALURL,
      sortBy: "createdAt",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      headers: [
        {
          text: this.$t("labels.cspID"),
          align: "left",
          sortable: true,
          value: "CSPID"
        },
        {
          text: this.$t("labels.name"),
          value: "businessName",
          sortable: true
        },
        {
          text: this.$t("labels.address"),
          value: "address",
          sortable: false
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "address",
          sortable: false
        },
        {
          text: this.$t("labels.emailAddress"),
          value: "address",
          sortable: false
        }
      ],
      search: null,
      loading: true
    };
  },
  computed: {
    ...mapGetters("global", ["currentOrganization", "currentUser", "organizationList"]),
    ...mapGetters("location", ["locations"])
  },
  methods: {
    viewLocation(location) {
      console.log("location", location);
      this.$router.push({ path: `location/${location.storeID}/profile` });
      // if (!this.hideHeader) {
      //   // this.setLocation(location.storeID);
      //   this.$router.push({ path: `${location.storeID}/profile`});
      // }
    }
  }
};
</script>
